<template lang="pug">
  div
    h4 <kbd>使用者清單資訊</kbd> 
    div.user-layout-head
      button.btn.btn-info.icon-right(@click="createForm = true") 新增使用者
      CreateUserForm(v-if="createForm" v-on:closeForm="closeForm")
      form.form-inline(@submit.prevent="onFilterSet")
        input.form-control.mr-2(type="text" v-model="username" placeholder="輸入帳號,姓或名")
        button.btn.btn-primary(type="submit") 搜尋
    h6 使用者清單
    vuetable(
      ref="vuetable"
      :api-url="`${server}/api/normal-user/`"
      data-path="results"
      pagination-path=""
      :per-page=20
      :fields="fields"
      :css="boostrapCss"
      :http-options="httpOptions"
      :append-params="moreParams" 
      detail-row-component="user-detail"
      @vuetable:pagination-data="onPaginationData"
      @vuetable:cell-clicked="onCellClicked")
    vuetable-pagination(
      ref="pagination"
      @vuetable-pagination:change-page="onChangePage"
      :css="boostrapCss.pagination" 
    )
</template>

<script>
import axios from 'axios';
import Vue from 'vue';
import VuetablePagination from 'vuetable-2/src/components/VuetablePagination';
import { mapState } from 'vuex';
import Vuetable from 'vuetable-2/src/components/Vuetable';
import readCookie from '@/vuex/functions/readCookie';
import server from '@/config';
import UserDetail from './UserDetail';
import CreateUserForm from '../../common/CreateUserForm';

Vue.component('user-detail', UserDetail);

export default {
  name: 'UserSettings',
  data() {
    return {
      boostrapCss: {
        tableClass: 'table table-striped table-sm',
        loadingClass: 'loading',
        ascendingIcon: 'glyphicon glyphicon-chevron-up',
        descendingIcon: 'glyphicon glyphicon-chevron-down',
        handleIcon: 'glyphicon glyphicon-menu-hamburger',
        pagination: {
          infoClass: '',
          wrapperClass: 'pagination',
          activeClass: 'page-active',
          disabledClass: 'disabled',
          pageClass: 'page-link',
          linkClass: 'page-link',
          icons: {
            first: '',
            prev: '',
            next: '',
            last: '',
          },
        },
      },
      httpOptions: {
        headers: {
          Authorization: `Token ${readCookie('Token')}`,
        },
      },
      server,
      fields: [
        {
          name: 'username',
          sortField: 'username',
          title: '帳號',
        },
        {
          name: 'last_name',
          sortField: 'last_name',
          title: '姓',
        },
        {
          name: 'first_name',
          sortField: 'first_name',
          title: '名',
        },
        // {
        //   name: 'email',
        //   title: '信箱',
        // },
        {
          name: 'title.name',
          title: '職稱',
        },
        {
          name: 'department.name',
          title: '所屬單位',
        },
        {
          name: 'barcode',
          title: '警員代碼',
        },
        // {
        //   name: 'med_app_privilege.name',
        //   title: '前台權限',
        // },
        // {
        //   name: 'server_privilege.name',
        //   title: '後台權限',
        // },
      ],
      createForm: false,
      username: '',
      moreParams: undefined,
    };
  },
  components: {
    Vuetable,
    VuetablePagination,
    CreateUserForm,
  },
  methods: {
    onCellClicked(data, field, event) {
      this.$refs.vuetable.toggleDetailRow(data.id);
    },
    onPaginationData(paginationData) {
      this.$refs.pagination.setPaginationData(paginationData);
    },
    onChangePage(page) {
      this.$refs.vuetable.changePage(page);
    },
    closeForm() {
      this.createForm = false;
    },
    onFilterSet() {
      this.moreParams = {
        search: this.username,
      };
      const vm = this;
      Vue.nextTick(() => this.$refs.vuetable.refresh());
    },
    getSortParam(sortOrder) {
      return sortOrder.map((sort) => {
        return (sort.direction === 'desc' ? '-' : '') + sort.field;
      }).join(',');
    },
  },
  computed: {
    instance() {
      return this.$store.state.instance;
    },
  },
  // computed: mapState({
  //   system: state => state.system,
  // }),
};
</script>

<style lang="sass">
.user-layout-head
  margin-bottom: 10px
</style>




// WEBPACK FOOTER //
// UserSettings.vue?76d6a9c6